import Dashboard from "layouts/Dashboard/Dashboard.jsx";

const indexRoutes = [{ path: "/", component: Dashboard }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx